export enum Grade {
  'A+' = 9,
  'A' = 8,
  'A-' = 7,
  'B+' = 6,
  'B' = 5,
  'B-' = 4,
  'C+' = 3,
  'C' = 2,
  'C-' = 1,
  'F' = 0,
}

export type GradeName =
  | 'A+'
  | 'A'
  | 'A-'
  | 'B+'
  | 'B'
  | 'B-'
  | 'C+'
  | 'C'
  | 'C-'
  | 'F';

// id => `${grade}__${region}__${country}__${paymentMethod}`

export interface Pricing {
  // Key
  grade: Grade;
  region: string;
  country: string;
  paymentMethod: string;

  // Rates
  merchantDiscountRate: string;
  transactionFee: string;
  payouts: string;
  creditFee: string;
  chargebackHandlingFee: string;
  rollingReserve: string;
}

// where grade: A, region: GCC, country: Lalala => []